<script>import Picker from "./Picker.svelte";
import { createEventDispatcher } from "svelte";
const _browser = typeof window !== "undefined";
export let name = void 0;
export let value = (/* @__PURE__ */ new Date()).getFullYear();
export let startBase = value === void 0 ? 3 : -1;
export let makeSquare = false;
const dispatch = createEventDispatcher();
let cellContentPadding = "0.2em";
let cellPadding = "0.3em";
let columns = 3;
const undefinedChar = "_";
const getYearAsLabel = (value2, base2) => {
  let yearStr2 = "";
  if (value2 === void 0 || value2 >= 0 && value2 < 1e4 && base2 >= 0) {
    if (value2 === void 0) {
      for (let i = 0; i < 4; i++) {
        yearStr2 += undefinedChar;
      }
    } else {
      yearStr2 = value2.toString().padStart(4, "0").substring(0, 3 - base2);
      for (let i = 0; i < base2 + 1; i++) {
        yearStr2 += undefinedChar;
      }
    }
  } else {
    yearStr2 = value2 !== void 0 ? value2.toString() : "";
  }
  return yearStr2;
};
const getCell = (cellIndex, start, base2, step) => {
  const monkey = Math.pow(10, 4) - 10 * step;
  if (cellIndex > 0 && cellIndex < 11) {
    const label = (start + step * (cellIndex - 1)).toString().padStart(4, "0");
    return {
      type: "primary",
      marked: false,
      selected: value === start + step * (cellIndex - 1),
      inside: false,
      value: start + step * (cellIndex - 1),
      label: `<div style="display:inline-block;"><span>${label.substring(
        0,
        2
      )}</span><br/><span>${label.substring(2, 4)}</span></div>`,
      valueTop: cellIndex < columns,
      valueLeft: cellIndex % columns === 0
    };
  } else if (cellIndex === 0) {
    return {
      type: start > 0 || base2 < 3 ? "secondary" : "spacer",
      marked: false,
      selected: false,
      inside: false,
      value: start > 0 ? start - 10 * step : -1 * (start - start % Math.pow(10, base2 + 2)),
      label: start > 0 ? '<span class="icon-chevron-left" style="line-height:2;" />' : base2 < 3 ? '<span class="icon-chevron-up" style="line-height:2;"/>' : "",
      valueTop: cellIndex < columns,
      valueLeft: cellIndex % columns === 0
    };
  } else {
    return {
      type: start < monkey || base2 < 3 ? "secondary" : "spacer",
      marked: false,
      selected: false,
      inside: false,
      value: start < monkey ? start + 10 * step : -1 * (start - start % Math.pow(10, base2 + 2)),
      label: start < monkey ? '<span class="icon-chevron-right" style="line-height:2;"/>' : base2 < 3 ? '<span class="icon-chevron-up" style="line-height:2;"/>' : "",
      valueTop: cellIndex < columns,
      valueLeft: cellIndex % columns === 0
    };
  }
};
let cells = [];
let base = startBase;
$:
  yearStr = getYearAsLabel(value, startBase);
$:
  partialValue = value !== void 0 && value >= 0 && value <= 9999 ? value - value % Math.pow(10, 1) : 0;
$: {
  if (base >= -1 && base <= 3 && (value === void 0 || value >= 0 && value <= 9999)) {
    cells = new Array(12);
    const step = Math.pow(10, base > 0 ? base : 0);
    for (let i = 0; i < 12; i++) {
      cells[i] = getCell(i, partialValue, base, step);
    }
  } else {
    cells = [];
  }
}
let inputFocus = false;
let open = false;
let inputElem;
let closingTimer;
const applyInputValue = () => {
  if (inputElem) {
    let trimmedInputValue = inputElem.value.trim();
    const isInCommonEra = trimmedInputValue.charAt(0) === "-";
    let i = isInCommonEra ? 1 : 0;
    while (i < trimmedInputValue.length && (isNaN(parseInt(trimmedInputValue.at(i))) || trimmedInputValue.at(i) === "0")) {
      i++;
    }
    trimmedInputValue = trimmedInputValue.substring(i);
    let cleanedString = isInCommonEra ? "-" : "";
    for (i = 0; i < trimmedInputValue.length; i++) {
      if (!isNaN(parseInt(trimmedInputValue.at(i)))) {
        cleanedString += trimmedInputValue.at(i);
      }
    }
    yearStr = cleanedString;
    inputElem.value = yearStr;
    let yr = parseInt(cleanedString);
    const yrStr = isNaN(yr) ? "" : yr.toString();
    if (yrStr.length === cleanedString.length) {
      yr = yrStr.length > 0 ? yr : void 0;
      const notify = yr !== value;
      value = yr;
      updatePicker();
      if (notify) {
        dispatch("changed", { name, value });
      }
    }
  }
};
const inputGotFocus = () => {
  inputFocus = true;
  if (cells !== void 0 && cells.length > 0) {
    open = true;
  }
  dispatch("action");
};
const inputLostFocus = () => {
  if (_browser) {
    closingTimer = window.setTimeout(() => {
      closingTimer = void 0;
      inputFocus = false;
      open = false;
      applyInputValue();
    }, 250);
  }
};
const abortClose = () => {
  if (closingTimer !== void 0) {
    if (_browser) {
      window.clearTimeout(closingTimer);
    }
    closingTimer = void 0;
  }
};
const cellClicked = (ev) => {
  const cell = ev.detail.cell;
  abortClose();
  if (cell && !cell.disabled) {
    if (cell.type === "primary" || cell.type === "secondary") {
      if (cell.type === "primary") {
        if (base > 0) {
          partialValue = cell.value;
          value = partialValue;
          base--;
          yearStr = getYearAsLabel(partialValue, base);
          inputElem.focus();
        } else {
          const notify = cell.value !== value;
          value = cell.value;
          partialValue = partialValue;
          base = -1;
          yearStr = getYearAsLabel(value, -1);
          open = false;
          if (notify) {
            dispatch("changed", { name, value });
          }
        }
      } else {
        if (cell.value > 0) {
          partialValue = cell.value;
        } else {
          partialValue = -1 * cell.value;
          base++;
          if (base > 3) {
            base = 3;
          }
        }
        inputElem.focus();
      }
    }
  } else {
    inputElem.focus();
  }
  dispatch("action");
};
const moveTo = (delta) => {
  console.log("year-picker moveTo with cur value = ", value);
  if (value !== void 0) {
    value += delta;
    updatePicker();
    yearStr = getYearAsLabel(value, -1);
    dispatch("changed", { name, value });
  }
  dispatch("action");
};
const updatePicker = () => {
  const yrStr = value !== void 0 ? value.toString() : "";
  if (yrStr.length < 5) {
    base = 3 - yrStr.length;
    if (value !== void 0) {
      if (yrStr.length === 4) {
        partialValue = value - value % Math.pow(10, 1);
      } else {
        partialValue = value * Math.pow(10, 4 - yrStr.length);
      }
    } else {
      partialValue = 0;
    }
  } else {
    open = false;
  }
};
</script>

<div class="picker year-picker">
	<span>
	<span
		class="button icon-chevron-left"
		on:keypress={(ev) => moveTo(-1)}
		on:click={(ev) => moveTo(-1)}
		role="button"
		tabindex="0"
/><span class="auto-width-input-wrap">
		<span class="width-adapter" aria-hidden="true"
			>{yearStr.length <= 4 ? '9999' : yearStr}
		</span><input
			tabindex="-1"
			bind:this={inputElem}
			type="text"
			value={yearStr}
			on:input={(ev) => applyInputValue()}
			on:focus={inputGotFocus}
			on:blur={inputLostFocus}
		/>
	</span><span
		class="button icon-chevron-right"
		on:keypress={(ev) => moveTo(+1)}
		on:click={(ev) => moveTo(+1)}
		role="button"
		tabindex="0"
/>
</span>
	<div class={open ? 'open' : ''}>
		<Picker
			{cells}
			itemCharWidth={2}
			itemCharHeight={2}
			{cellContentPadding}
			{cellPadding}
			{columns}
			{makeSquare}
			on:cell-click={cellClicked}
		/>
	</div>
</div>

<style>
	div.picker {
		--base-color-onSurface-primary: #dbe4e7;
		--base-color-primary-default: #6bae85;
		--font-family: Roboto;
		--font-size: 1.125rem;
		--font-weight: 700;
		--letter-spacing: 0.0625rem;
	}

	div.picker {
		--picker-font: normal var(--font-weight) var(--font-size) / 1.2 var(--font-family);
		--picker-font-spacing: var(--letter-spacing);
		--picker-text-color: var(--base-color-onSurface-primary);
		--picker-button-color: var(--base-color-primary-default);
		--magic-number: 0.5em; /*space given to blinking cursor in input. MAGIC NUMBER Chrome & Firefox*/
	}

	div.picker.year-picker {
		display: inline-block;
		vertical-align: bottom;
	}

	.picker input,
	.picker > span > span {
		background-color: transparent;
		color: var(--picker-text-color);
		font: var(--picker-font);
		letter-spacing: var(--picker-font-spacing);
		line-height: 1.22222;
	}

	.picker input {
		outline: none;
		border: 1px solid transparent;
		padding: 0;
		margin: 0;
	}

	.year-picker > span > .auto-width-input-wrap .width-adapter {
		border: 1px solid transparent;
	}

	.picker > div {
		position: absolute;
		display: none;
		left:0;
	}
	.picker > div.open {
		display: block;
		z-index: 10000;
	}

	/* style for auto growing of the input*/
	.auto-width-input-wrap {
		position: relative;
		margin-left: calc(1em - var(--magic-number));
	}

	.auto-width-input-wrap input {
		position: absolute;
		width: calc(100% - 1em + var(--magic-number));
		left: 0;
	}

	.auto-width-input-wrap .width-adapter {
		visibility: hidden;
		color: transparent;
		margin-right: calc( var(--magic-number) ); /*space given to blinking cursor in input. MAGIC NUMBER*/
	}

	div.picker.year-picker > span {
		display:inline-flex;
		align-items:center;
		align-content:stretch;
		gap: 0em;
	}

	div.picker.year-picker > span > span.auto-width-input-wrap {
		flex:1 0 auto;
	}
	div.picker.year-picker > span > span.button {
		flex: 0 0 auto;
		cursor:pointer;
	}

</style>
